module.exports = __webpack_public_path__ + "img/dadata-icon.0410f962.svg";